import React, { useState } from "react";
import styles from "./NewProduct.module.sass";

import PrintBarcodeTemplate from "./PrintBarcodeTemplate";

import Preview from "./Preview";

const PrintBarcode = () => {
  const [visiblePreview, setVisiblePreview] = useState(false);

  return (
    <>
      <div className={styles.row}>
        <div className={styles.col}>
          <PrintBarcodeTemplate className={styles.card} />
        </div>
        <div className={styles.col}>
          <Preview
            visible={visiblePreview}
            onClose={() => setVisiblePreview(false)}
          />
        </div>
      </div>
    </>
  );
};

export default PrintBarcode;
